import React, { useState, useEffect, useRef } from 'react';
import SettingsTabs from 'components/quote_builder/SettingsTabs.jsx';
import SettingsMenu from 'components/quote_builder/SettingsMenu.jsx';
import { GetRequest } from 'components/common';

const Settings = ( {config, user_unit_price_key, edit_id, new_key} ) => {
  const [activeItem, setActiveItem] = useState(isMobile() ? undefined : (new_key || user_unit_price_key || getCookie('quote_builder_default_settings_item') || "carton_material") );
  const [editIdToPass, setEditIdToPass] = useState(edit_id ? parseInt(edit_id, 10) : null);
  const [showNewForm, setShowNewForm] = useState(!!new_key);
  const [isLoadingSection, setIsLoadingSection] = useState(!!edit_id);

  // Fetch the section key for the edit_id and set the active menu item
  useEffect(() => {
    let isCancelled = false;

    if (edit_id && !user_unit_price_key) {
      setIsLoadingSection(true);
      GetRequest({
        url: `/quote-builder/user_unit_prices/${edit_id}/section_key`,
        callback: (data) => {
          if (isCancelled) return;
          if (data.key) {
            setActiveItem(data.key);
          }
          setIsLoadingSection(false);
        },
        404: () => {
          if (isCancelled) return;
          setIsLoadingSection(false);
          // If not found, redirect to settings without edit
          window.history.replaceState({}, '', '/quote-builder/settings');
        }
      });
    }

    return () => {
      isCancelled = true;
    };
  }, [edit_id, user_unit_price_key]);

  // Track if section change is from user menu interaction vs initial load
  const isUserMenuNavigation = useRef(false);

  const handleSetActiveItem = (item) => {
    isUserMenuNavigation.current = true;
    setActiveItem(item);
  };

  useEffect(() => {
    $("html, body").animate({ scrollTop: 100 }, "slow");
    // Clear edit/new states when user navigates via menu (not initial load)
    if (isUserMenuNavigation.current) {
      setEditIdToPass(null);
      setShowNewForm(false);
      window.history.replaceState({}, '', '/quote-builder/settings');
      isUserMenuNavigation.current = false;
    }
  }, [activeItem])

  if (isLoadingSection) {
    return (
      <div className="row" style={{"marginLeft": "-30px"}}>
        <div className="col-lg-12 text-center">
          <p>{t('quote_builder.please_wait')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="row" style={{"marginLeft": "-30px"}}>
      <div className="col-lg-3 SettingsMenu">
        <SettingsMenu activeItem={activeItem} setActiveItem={handleSetActiveItem} />
      </div>
      <div className="col-lg-9 SettingsMenuMainCont">
        {activeItem == "carton_material" && <SettingsTabs config={config.user_unit_prices.carton_material}
          breadcrumbs="materials,menu_material_cartons" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "hard_cardboard_material" && <SettingsTabs config={config.user_unit_prices.hard_cardboard_material}
          breadcrumbs="materials,menu_material_hard_cardboards" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "corrugated_cardboard_material" && <SettingsTabs config={config.user_unit_prices.corrugated_cardboard_material}
          breadcrumbs="materials,menu_material_corrugated_cardboards" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "pvc_material" && <SettingsTabs config={config.user_unit_prices.pvc_material}
          breadcrumbs="materials,menu_material_pvc" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "coating_material" && <SettingsTabs config={config.user_unit_prices.coating_material}
          breadcrumbs="materials,menu_material_coating" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "hot_stamping_material" && <SettingsTabs config={config.user_unit_prices.hot_stamping_material}
          breadcrumbs="menu_hot_stamping,menu_materials" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "hot_stamping_printing_block" && <SettingsTabs config={config.user_unit_prices.hot_stamping_printing_block}
          breadcrumbs="menu_hot_stamping,menu_printing_blocks" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "hot_stamping_machine" && <SettingsTabs config={config.user_unit_prices.hot_stamping_machine}
          breadcrumbs="menu_hot_stamping,menu_machines" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "cellophane_material" && <SettingsTabs config={config.user_unit_prices.cellophane_material}
          breadcrumbs="menu_cellophane,menu_materials" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "cellophane_machine" && <SettingsTabs config={config.user_unit_prices.cellophane_machine}
          breadcrumbs="menu_cellophane,menu_machines" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "printing_machine" && <SettingsTabs config={config.user_unit_prices.printing_machine}
          breadcrumbs="menu_print,printing_machine" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "guillotine_machine" && <SettingsTabs config={config.user_unit_prices.guillotine_machine}
          breadcrumbs="guillotine_cutting,menu_guillotine_machines" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "die_cutting_machine" && <SettingsTabs config={config.user_unit_prices.die_cutting_machine}
          breadcrumbs="menu_cutting,menu_die_cutting_machines" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "metal_strip" && <SettingsTabs config={config.user_unit_prices.metal_strip}
          breadcrumbs="menu_cutting,menu_metal_strips" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "cutting_board" && <SettingsTabs config={config.user_unit_prices.cutting_board}
          breadcrumbs="menu_cutting,menu_cutting_boards" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "glueing_machine" && <SettingsTabs config={config.user_unit_prices.glueing_machine}
          breadcrumbs="glueing,glueing_machines" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "glueing_manual_labor" && <SettingsTabs config={config.user_unit_prices.glueing_manual_labor}
          breadcrumbs="glueing,glueing_manual_labor" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "glueing_material" && <SettingsTabs config={config.user_unit_prices.glueing_material}
          breadcrumbs="glueing,glueing_materials" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "lamination_machine" && <SettingsTabs config={config.user_unit_prices.lamination_machine}
          breadcrumbs="lamination,lamination_machines" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "lamination_manual_labor" && <SettingsTabs config={config.user_unit_prices.lamination_manual_labor}
          breadcrumbs="lamination,lamination_manual_labor" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "magnet_material" && <SettingsTabs config={config.user_unit_prices.magnet_material}
          breadcrumbs="menu_magnet,menu_magnets" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "coating_machine" && <SettingsTabs config={config.user_unit_prices.coating_machine}
          breadcrumbs="menu_coating_labour,coating_machine" editId={editIdToPass} showNewForm={showNewForm} /> }

        {activeItem == "coating_manual_labor" && <SettingsTabs config={config.user_unit_prices.coating_manual_labor}
        breadcrumbs="menu_coating_labour,coating_manual_labor" editId={editIdToPass} showNewForm={showNewForm} /> }

      </div>
    </div>
  )
}

export default Settings;
